import React from 'react';
import Modal from 'components/new_ui/Modal/Modal';
import PropTypes from 'prop-types';
import { useClaimContext } from 'contexts/ClaimContext';
import Alert from 'components/new_ui/Alerts/alert';
import Form from '../Form';

export default function Index({ claim, onCloseClick }) {
  const { dispatch, actions } = useClaimContext();

  const formSendSuccess = () => {
    Alert({
      title: 'Claim Updated!',
      text: "Our claim's specialist will reach out to you shortly.",
      confirmButtonText: 'Close',
    });
  };

  const onSubmit = (values, { setSubmitting }) => {
    actions.updateClaim(dispatch, claim.id, values, () => {
      setSubmitting(false);
      onCloseClick();
      formSendSuccess();
      actions.loadClaims(dispatch);
    });
  };

  return (
    <Modal show={claim !== null}>
      <Form claim={claim} onCloseClick={onCloseClick} onSubmit={onSubmit} />
    </Modal>
  );
}

Index.propTypes = {
  claim: PropTypes.object.isRequired,
  onCloseClick: PropTypes.func.isRequired,
};
